<template>
  <div>
    <img src="/static/img/access_07.png">
  </div>
</template>
<script>
import menu from '@/api/menu';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mapState } from 'vuex';
import moment from 'moment';
import timezone from 'moment-timezone';
import debounce from 'lodash.debounce';
import Util from '@/util';

export default {
  components: {
    DatePicker,
  },
  data: () => ({
    isVideoMeeting: false,
    meeting: {
      nowStart: false,
      creator: {
        userKey: 'admin',
      },
      title: '',
      startDate: moment().format('YYYY.MM.DD'),
      startTime: '11:00',
      startDtime: null,
      endDate: moment().format('YYYY.MM.DD'),
      endTime: '18:00',
      endDtime: null,
      attendees: [],
      conferenceRooms: [],
      interlockSystem: 'flow',
    },
    meetingList: [],
    meetingTimeList: [],
    attCount: 0,
    confCount: 0,
    sampleAttendeesList: ['admin', 'ksd1', 'ksd2', 'ksd3', 'ksd4'],
    sampleConfereceRoomList: ['1050', '1099', '1360', '1398', '1370'],
    lang: {
      days: ['일', '월', '화', '수', '목', '금', '토'],
      months: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ],
      yearFormat: 'YYYY년',
      monthFormat: 'MM월',
      // the calendar title of month before year
      monthBeforeYear: false,
    },
    changeDate(date) {
      this.meeting.conferenceRooms = [];
      this.meetingConferenceDialog.conferenceRooms = [];
      this.selectedConferenceRoomString = null;
    },
    changedstartTime() {
      this.meeting.conferenceRooms = [];
      this.meetingConferenceDialog.conferenceRooms = [];
      this.selectedConferenceRoomString = null;
    },
    changedendTime() {
      this.meeting.conferenceRooms = [];
      this.meetingConferenceDialog.conferenceRooms = [];
      this.selectedConferenceRoomString = null;
    },
    addAttendee() {
      console.log('addAttendee');
      if (this.attCount < 5) {
        this.meeting.attendees.push(this.sampleAttendeesList[this.attCount]);
        this.attCount = this.attCount + 1;
      }
    },
    addConf() {
      console.log('addConf');
      if (this.confCount < 5) {
        this.meeting.conferenceRooms.push(
          this.sampleConfereceRoomList[this.meeting.conferenceRooms.length]
        );
        this.confCount = this.confCount + 1;
      }
      console.log(`this.meeting.conferenceRooms`, this.meeting.conferenceRooms);
    },
    async createMeeting() {
      if (this.meeting.nowStart === true) {
        this.meeting.startDtime = moment.utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
      } else {
        this.meeting.startDtime = moment
          .tz(
            `${this.meeting.startDate.replace(/\./g, '-')} ${
              this.meeting.startTime
            }`,
            'Asia/Seoul'
          )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss[Z]');
      }

      this.meeting.endDtime = moment
        .tz(
          `${this.meeting.startDate.replace(/\./g, '-')} ${
            this.meeting.endTime
          }`,
          'Asia/Seoul'
        )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');

      // this.meeting.conferenceRooms = this.meeting.conferenceRooms.map(el => el.confId);
      await this.$http
        .post('/api/v1/meetings/ksd/createMeeting', this.meeting)
        .then((response) => {
          console.log('response : ', response);
          if (response.data.success === true) {
            alert(
              '미팅 생성 성공 meetingKey: ' + response.data.data.meetingKey
            );
            this.init();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  }),
  async mounted() {
    this.init();
  },
  methods: {
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    async init() {
      this.attCount = 0;
      this.confCount = 0;
      this.meeting = {
        nowStart: false,
        creator: {
          userKey: 'admin',
        },
        title: '',
        startDate: moment().format('YYYY.MM.DD'),
        startTime: moment().add(25, 'm').format('HH:mm'),
        startDtime: null,
        endDate: moment().format('YYYY.MM.DD'),
        endTime: '18:00',
        endDtime: null,
        attendees: [],
        conferenceRooms: [],
        interlockSystem: 'flow',
      };

      let params = {
        status: 'r',
      };

      // 전체 화상장비 리스트 가져오기 (화상장비 수정 시 Key 값 안맞기 때문에 backend에서 가져와서 리스트 매핑 시킴.)
      await this.$http
        .get(`/api/v1/devices`)
        .then((response) => {
          const deviceList = response.data;
          const snList = deviceList.filter((d) => d.sn).map((d) => d.sn);
          // sampleConfereceRoomList 초기화
          this.sampleConfereceRoomList = snList;
          console.log(
            `this.sampleConfereceRoomList`,
            this.sampleConfereceRoomList
          );
        })
        .catch((error) => {
          console.log(error);
        });

      await this.$http
        .get('/api/v1/meetings/ksd/getMeeting', { params: params })
        .then((response) => {
          console.log(`response : `, response);
          this.meetingList = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    nowStartChange() {
      if (this.meeting.nowStart === true) {
        this.meeting.startTime = '즉시';
      } else {
        this.meeting.startTime = moment().add(5, 'm').format('HH:mm');
      }
    },
    initTimeData() {
      this.meetingTimeList = [];
      let meetingInterval = 10;
      let time = moment();
      let startDate = moment(time.format('YYYY.MM.DD'));
      let endDate = time.clone().add(1, 'day').format('YYYY.MM.DD');
      while (startDate.format('YYYY.MM.DD') < endDate) {
        this.meetingTimeList.push(startDate.format('HH:mm'));
        startDate = startDate.add(meetingInterval, 'minutes');
      }

      let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);

      this.meeting.startTime = nearestFuture.format('HH:mm');
      this.meeting.endTime = nearestFuture.add(30, 'minutes').format('HH:mm');
    },
    settingMeeting(meetingKey) {
      window.open(
        `/checkAgent?meetingKey=${meetingKey}`,
        `_blank`,
        `width=950, height=700`
      );
    },
    startMeeting(meetingKey) {
      window.open(
        `/attendMeeting?meetingKey=${meetingKey}&userKey=admin`,
        `_blank`,
        `width=750, height=800`
      );
    },
  },
};
</script>
<style scoped>
.join-btn {
  background: #7dc3ff;
  width: 300px;
  font-size: 25pt;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  display: inline-block;
  margin-top: 30px;
}

.download-header {
  background: #1457aa;
  color: white;
  font-weight: 300;
}

.download-contents {
  font-size: 13pt;
  padding: 10px 0;
  font-weight: 100;
}
#downloadBtn {
  width: 200px;
  height: 50px;
  background: #1457aa;
  display: inline-block;
  color: white;
  border-radius: 5px;
  font-size: 14pt;
  margin-top: 20px;
  line-height: 50px;
  cursor: pointer;
}

#closeBtn {
  width: 100px;
  height: 40px;
  background: #9fa9ae;
  display: inline-block;
  color: white;
  border-radius: 5px;
  font-size: 14pt;
  margin-top: 10px;
  line-height: 40px;
  margin-bottom: 20px;
  cursor: pointer;
}

#here {
  width: 100%;
  text-align: center;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.02) 0%,
      rgba(0, 0, 0, 0.02) 100%
    ),
    linear-gradient(
      0deg,
      rgba(0, 143, 111, 0.08) 0%,
      rgba(0, 143, 111, 0.08) 100%
    ),
    #fff;
}

.attend-main-title {
  color: #333;
  text-align: center;
  font-family: 'Noto Sans KR';
  font-size: 52px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 78px */
  letter-spacing: -1.04px;
  margin-top: 10%;
}

.attend-btn {
  border-radius: 12px;
  border: 1px solid #008f6f;
  background: #fff;
  display: inline-flex;
  padding: 18px 48px;
  flex-direction: column;
  align-items: flex-start;
  color: #008f6f;
  text-align: center;
  font-family: 'Noto Sans KR';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 30px */
  letter-spacing: -0.4px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/KsdTest.vue